import React from 'react';
import { RouteObject } from 'react-router-dom';

import { UserRole } from '@/shared/enums/user-role.enum';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const PartnerModulesContainer = React.lazy(
  () => import('../../containers/partner-modules/partner-modules.container')
);

export const PartnerModulesRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={PartnerModulesContainer}
        />
      </React.Suspense>
    )
  }
];
